/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { arr_inArray, htmlspecialchars, set_parameter_on_url_search, array_unique, clip, elementHasClassName } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { mj } from './page-mj.js';
import { $ } from '../other/jquery-hooked.js';

import { MDLocale } from './locale-impl.js';

import { mjWidgetOverlayEditor } from './widget-overlay-editor.js';

import { MVPageDebug } from './page-debug-view.js';

import { tinycolor } from '../vendor/tinycolor.js';



export function SetupWebUIDebuggingOverlay() {

	var vis = null;

	function set_web_ui_debugging_features( web_ui_debugging ) {
		var url = document.location.href;
		var search = document.location.search;
		var hash = document.location.hash;
		if( url.indexOf('#')!=-1 ) url = url.substr( 0, url.indexOf('#') );
		if( url.indexOf('?')!=-1 ) url = url.substr( 0, url.indexOf('?') );
		search = set_parameter_on_url_search(search,'web_ui_debugging',web_ui_debugging);
		const oldHref = document.location.href;
		const newHref = url + search + hash;
		if( newHref !== oldHref ) {
			document.location.href = newHref;
			return true;
		}
		return false;
	}

	var ovl_div = $('#web-ui-debugging-overlay');
	ovl_div.show();

	ovl_div.find('.oc.minimize').click( function() {
		var xsmall = ovl_div.hasClass('xsmall');
		if( xsmall ) ovl_div.removeClass('xsmall');
		else ovl_div.addClass('closed xsmall');
		ovl_div.find('.oc.minimize').toggle( xsmall );
	} );
	ovl_div.find('.oc.restore').click( function() {
		const closed = ovl_div.hasClass('closed');
		if( closed ) ovl_div.removeClass('closed xsmall');
		else ovl_div.addClass('closed');
		ovl_div.find('.oc.minimize').toggle( closed );
	} );

	$('#web-ui-debugging-overlay .web-ui-debugging-feature').click( function() {
		ovl_div.find('.link').addClass('disabled');
		const feat_div = $(this);
		const newState = !feat_div.hasClass('enabled');
		feat_div.toggleClass('enabled',newState);
		feat_div.find('>span.state').toggleClass('fa-check-circle-o',newState).toggleClass('fa-circle-o',!newState);
		let features = [];
		$('#web-ui-debugging-overlay .web-ui-debugging-feature').each( function() {
			const self = $(this);
			const inverted = self.data('web-ui-debugging-feature-inverted');
			if( inverted && !self.is('.enabled') ) {
				features.push(inverted);
			} else if( !inverted && self.is('.enabled') ) {
				var feat = self.data('web-ui-debugging-feature');
				features.push(feat);
			}
		} );
		$('#web-ui-debugging-overlay').toggleClass('some-enabled',features.length!==0);
		// console.log({features});
		set_web_ui_debugging_features( features.join(',') );
	} );

	$('#web-ui-debugging-devpro .link').click( function() {
		startProgress();
		ovl_div.find('.link').addClass('disabled');
		const self = $(this);
		const devpro = self.data('web-ui-debugging-devpro');
		let changedLocation = false;
		if( devpro==='production' ) changedLocation = set_web_ui_debugging_features('');
		else changedLocation = set_web_ui_debugging_features('no-minify,no-js-bundling,priv-js-caches');
		if( !changedLocation ) {
			ovl_div.find('.link').removeClass('disabled');
			stopProgress();
			ovl_div.find('.restore').click();
		}
	} );

	// track list of past exceptions ..
	var backend_errors_list = [];
	// register for backend exceptions from ajax calls
	mj.backend_exception_hook = function( j, http_method, request_uri, request_data, triggerErrorUI ) {
		// eslint-disable-next-line no-console
		console.trace(['mj.backend_exception_hook',j]);
		backend_errors_list.push( [ j, Date.now(), http_method, request_uri, request_data ] );
		$('#web-ui-debugging-status-exceptions').toggleClass('link enabled',backend_errors_list.length>0);
		$('#web-ui-debugging-status-exceptions-count').text(backend_errors_list.length);
		if( triggerErrorUI ) {
			setTimeout( function() {
				$('#web-ui-debugging-status-exceptions').trigger('click');
			}, 100 );
		}
	};

	function getBackendErrorInnerDStr( e, prev_idx, previous_errors ) {
		var indent_str = '   ';
		var r = e.error + ': ' + e.message + "\n";

		if( e.error_details && e.error_details!=='' && e.error_details!==null ) {
			var details = $.trim(e.error_details);
			r += '>Details:' + "\n";
			r += indent_str + details.replace(/\n/g,"\n"+indent_str) + "\n";
		}

		r += '>Stacktrace:' + "\n";
		for( var i in e.trace ) {
			if( !e.trace.hasOwnProperty(i) ) continue;
			r += indent_str + e.trace[i] + "\n";
		}

		if( previous_errors && previous_errors.length && prev_idx<previous_errors.length ) {
			var prev = previous_errors[prev_idx];
			if( prev!==null ) {
				var prev_str = getBackendErrorInnerDStr(prev,prev_idx+1,previous_errors);
				r += '>Previous:' + "\n";
				r += indent_str + prev_str.replace(/\n/g,"\n"+indent_str) + "\n";
			}
		}
		return r;
	}

	function getBackendErrorDisplayString( e, prev_idx ) {
		return getBackendErrorInnerDStr(e,0,e.previous_errors);
	}

	$('#web-ui-debugging-status-exceptions').on( 'click', function(e) {
		if( !$(this).hasClass('enabled') || $(this).hasClass('disabled') ) return false;
		MVPageDebug.reset(true);
		MVPageDebug.dprint_html( 'Exception List', 'header', 'pre' );
		for( var ei in backend_errors_list ) {
			if( !backend_errors_list.hasOwnProperty(ei) ) continue;
			var bei = backend_errors_list[ei];
			var estr = getBackendErrorDisplayString(bei[0]);
			if( bei[2] && bei[3] ) {
				// add http_method, request_uri, request_data
				var pfx = bei[2]+' '+bei[3];
				if( bei[4] ) pfx += ' ('+$.dump(bei[4])+')';
				estr = pfx+':\n'+estr;
			}
			MVPageDebug.dprint_str( estr, bei[1] );
		}
		MVPageDebug.dprint_html( '', 'footer', '' );
	} );


	var info_list = [];
	mj.info_hook = function( text ) {
		// eslint-disable-next-line no-console
		//console.trace(['mj.info_hook',text]);
		if( arguments.length > 2 ) {
			const onclick = arguments[2];
			let onclick_str = onclick.toString();
			if( onclick instanceof Function ) {
				onclick_str = "("+onclick_str.trim()+")(event)";
			}
			let xtra_html = '<a class="link" href="'+htmlspecialchars(arguments[1],true,true)+'" target="_blank" onclick="'+htmlspecialchars(onclick_str,true,true)+'">'+htmlspecialchars(arguments[1],false,true)+'</a>';
			if( arguments.length > 3 ) xtra_html += '<span>'+htmlspecialchars(arguments[3],false,true)+'</span>';
			info_list.push( [ text, Date.now(), xtra_html ] );
		} else if( arguments.length === 2 ) {
			info_list.push( [ text, Date.now(), arguments[1] ]  );
		} else {
			info_list.push( [ text, Date.now() ]  );
		}
		$('#web-ui-debugging-status-info').toggleClass('link enabled',info_list.length>0);
		$('#web-ui-debugging-status-info-count').text(info_list.length);
	};

	$('#web-ui-debugging-status-info').on( 'click', function(e) {
		if( !$(this).hasClass('enabled') || $(this).hasClass('disabled') ) return false;
		MVPageDebug.reset();
		MVPageDebug.dprint_html( 'Status Info List', 'header', 'pre' );
		for( var ii in info_list ) {
			if( !info_list.hasOwnProperty(ii) ) continue;
			const info = info_list[ii];
			let str = info[0];
			if( info.length===3 ) {
				const html = info[2].replaceAll(/<(br|\/div|\/p|\/pre)>/g,'<$1>\n');
				if( str.length ) str += "\n";
				str += $(html).text();
			}
			MVPageDebug.dprint_str( str, info[1] );
		}
		MVPageDebug.dprint_html( '', 'footer', '' );
	} );


	function update_debug_info_states( type, di, dom_id ) {
		var cur_len = mj.debug[type].length || 0;
		$(dom_id).toggleClass('link enabled',cur_len>0);
		$(dom_id+'-count').text(cur_len);
		var add_len = di[type].length || 0;
		var batch_start_idx = cur_len - add_len;
		if( batch_start_idx >=0 && batch_start_idx < cur_len ) mj.debug[type][batch_start_idx].batch_start = true;
	}

	var add_debug_info_hook_count = 0;
	mj.add_debug_info_hook = function( di ) {
		update_debug_info_states('templates_rendered',di,'#web-ui-debugging-status-templates');
		update_debug_info_states('styles_involved',di,'#web-ui-debugging-status-styles');
		++add_debug_info_hook_count;
	};
	// call hook for the first time .. (but note: when caches are hot, then browser may already have called it)
	if( add_debug_info_hook_count===0 && mj.debug ) mj.add_debug_info_hook(mj.debug);


	function colorized_skin_path_html( path ) {
		var path_prefix_wrappers = {
			// from default skin
			'public/skin/d/': 			{ open:'<span style="color:#ff4439">', close:'</span>' },
			// from any other skin
			'public/skin/':				{ expandTo:'/', open:'<span style="color:#fff286">', close:'</span>' },
			// from g dir
			'public/g/':				{ expandTo:'/', open:'<span style="color:#99ff6b">', close:'</span>' },
			// from cache dir
			'public/cache/':			{ expandTo:'/', open:'<span style="color:#99cbff">', close:'</span>' },
			// from 3rdparty dir
			'public/3rdparty':			{ expandTo:'/', open:'<span style="color:#cbabff">', close:'</span>' },
			// from custom template
			'public/custom': 			{ expandTo:'/', open:'<span style="color:#ff6bee">', close:'</span>' },
			// from add-ons
			'ext/':			 			{ expandTo:'/skin/d/', open:'<span style="color:#6bffe4">', close:'</span>' },
		};
		var path_html = '';
		var path_offs = 0;
		var pfx, ppw, o;
		for( pfx in path_prefix_wrappers ) {
			if( path.startsWith(pfx) ) {
				ppw = path_prefix_wrappers[pfx];
				path_offs = pfx.length;
				if( ppw.expandTo ) {
					if( (o=path.indexOf(ppw.expandTo,path_offs))!==-1 ) path_offs = o+ppw.expandTo.length;
				}
				path_html += ppw.open + htmlspecialchars(path.substr(0,path_offs),false,true) + ppw.close;
				break;
			}
		}
		path_html += htmlspecialchars(path.substr(path_offs),false,true);
		return path_html;
	}

	$('#web-ui-debugging-status-templates').on( 'click', function(e) {
		if( !$(this).hasClass('enabled') || $(this).hasClass('disabled') ) return false;
		MVPageDebug.reset();
		MVPageDebug.dprint_html( 'Templates rendered', 'header', 'pre' );

		var head_html =
				'<span class="trow">'
					+'<span class="tcell" style="max-width:23%">template_name</span>'
					+'<span class="tcell" style="max-width:108px; text-align:right; padding-right:4px; font-size:78%">file modified</span>'
					+'<span class="tcell" style="max-width:108px; text-align:right; padding-right:4px; font-size:78%">cache modified</span>'
					+'<span class="tcell">path</span>'
					+'<span class="tcell" style="max-width:60px; text-align:center">type</span>'
					+'<span class="tcell" style="max-width:60px; text-align:right; padding-right:8px" title=" render time (ms)">rt ms</span>'
				+'</span>';
		MVPageDebug.dprint_html( head_html, 'header', 'tab' );

		var i, l=mj.debug.templates_rendered.length;
		for( i=0; i<l; ++i ) {
			var entry = mj.debug.templates_rendered[i];
			var diff_ts_str = '';
			if( entry.end_ts!==null ) {
				var diff_ts = entry.end_ts-entry.start_ts;
				diff_ts_str = diff_ts.toFixed(2);
				// var fc = 8-diff_ts_str.length;
				// if( fc>0 ) diff_ts_str = '<span class="ws" data-vis="'+str_repeat('·',fc)+'">'+str_repeat(' ',fc)+'</span>' + diff_ts_str;
			}
			var path_html = colorized_skin_path_html(entry.path);

			var entry_html =
				'<span class="trow">'
					+'<span class="tcell" style="max-width:23%">'+htmlspecialchars(entry.name,false,true)+'</span>'
					+'<span class="tcell" style="max-width:108px; text-align:right; padding-right:4px; font-size:78%">'+(entry.file_dmtime===false?'':MDLocale.fmt_duration_fancy(entry.file_dmtime,false,3))+'</span>'
					+'<span class="tcell" style="max-width:108px; text-align:right; padding-right:4px; font-size:78%">'+(entry.cache_dmtime===false?'':MDLocale.fmt_duration_fancy(entry.cache_dmtime,false,3))+'</span>'
					+'<span class="tcell">'+path_html+'</span>'
					+'<span class="tcell" style="max-width:60px; text-align:center">'+htmlspecialchars(entry.type,false,true)+'</span>'
					+'<span class="tcell" style="max-width:60px; text-align:right; padding-right:8px">'+diff_ts_str+'</span>'
				+'</span>';
			MVPageDebug.dprint_html( entry_html, entry.batch_start ? Math.floor(entry.start_ts) : null, 'tab' );
		}
		MVPageDebug.dprint_html( '', 'footer', '' );
	} );


	var colorized_style_paths_codes = {};
	var colorized_style_paths_next_code = 1;

	function colorized_style_path_html( path, parent_path, type ) {
		var cpath_html = colorized_skin_path_html(path);
		if( path.endsWith('.css') ) cpath_html = '<b>'+cpath_html+'</b>';

		var code = 0;
		if( colorized_style_paths_codes.hasOwnProperty(path) ) code = colorized_style_paths_codes[path];
		else code = colorized_style_paths_codes[path] = ++colorized_style_paths_next_code;

		var pcode = 0;
		if( parent_path && colorized_style_paths_codes.hasOwnProperty(parent_path) ) pcode = colorized_style_paths_codes[parent_path];

		return '<span class="tcell-csp cspc-'+code
					+(pcode?' csppc-'+pcode:'')
					+(' style-topo-'+type)				// css classes 'style-topo-path' and 'style-topo-dep'
					+'" data-cspc="'+code+'"'
					+(pcode?' data-csppc="'+pcode+'"':'')
					+' data-path="'+htmlspecialchars(path,true,true)+'"'
					+' tabindex="0">'
					+'<span class="tcell-path">'+cpath_html+'</span>'
					+'<span class="tcell-rank"></span>'
					+'</span>';
	}


	$('#web-ui-debugging-status-styles').on( 'click', function(e) {
		if( !$(this).hasClass('enabled') || $(this).hasClass('disabled') ) return false;
		MVPageDebug.reset();
		setup_additional_style_debug_utils();
		MVPageDebug.dprint_html( 'Stylesheets involved', 'header', 'pre' );

		var head_html =
				'<span class="trow">'
					+'<span class="tcell" style="max-width:36px; text-align:center">sent</span>'
					+'<span class="tcell" style="max-width:62px; text-align:right; padding-right:6px; font-size:87%">size</span>'
					+'<span class="tcell" style="max-width:128px; text-align:right; padding-right:4px; font-size:78%">modified</span>'
					+'<span class="tcell">@imports / compiled from</span>'
					+'<span class="tcell" style="max-width:44%">path</span>'
				+'</span>';
		MVPageDebug.dprint_html( head_html, 'header', 'tab' );

		var i, l=mj.debug.styles_involved.length;
		var entry;
		for( i=0; i<l; ++i ) {
			entry = mj.debug.styles_involved[i];
			var path_html = colorized_style_path_html(entry.path,null,'path');
			var deps_html = '';
			if( entry.deps ) {
				for( var d=0; d<entry.deps.length; ++d ) {
					deps_html += colorized_style_path_html(entry.deps[d],entry.path,'dep') + '<br>';
				}
			}
			if( deps_html!=='' ) {
				deps_html = '<span class="tcell-conn tcell-conn-tr">»</span>' + deps_html;
			} else {
				deps_html = '<span class="tcell-conn tcell-conn-eq">=</span>' + deps_html;
			}
			var entry_html =
				'<span class="trow">'
					+'<span class="tcell" style="max-width:36px; text-align:center">'+(entry.sent?' X ':' &nbsp; ')+'</span>'
					+'<span class="tcell" style="max-width:62px; text-align:right; padding-right:6px; font-size:87%">'+MDLocale.fmt_filesize(entry.size)+'</span>'
					+'<span class="tcell" style="max-width:128px; text-align:right; padding-right:4px; font-size:78%">'+MDLocale.fmt_duration_fancy(entry.dmtime,false,3)+'</span>'
					+'<span class="tcell">'+deps_html+'</span>'
					+'<span class="tcell" style="max-width:44%">'+path_html+'</span>'
				+'</span>';
			MVPageDebug.dprint_html( entry_html, null, 'tab' );
		}
		MVPageDebug.dprint_html( '', 'footer', '' );
	} );


	var selectedPaths = [];

	function get_styles_dependent_on( style_path ) {
		var i, l=mj.debug.styles_involved.length;
		var entry;
		var result = [];
		for( i=0; i<l; ++i ) {
			entry = mj.debug.styles_involved[i];
			if( entry.deps ) {
				for( var d=0; d<entry.deps.length; ++d ) {
					if( entry.deps[d]===style_path ) result.push(entry.path);
				}
			}
		}
		return array_unique(result);
	}

	function withEachStyleTargetByPath( paths_arr, fn, filter_class ) {
		// NOTE: selecting by path data must be escaped correctly... this is the slow, but safe method:
		var $allTargets = $('#dprint .tcell-csp'+(filter_class?'.'+filter_class:''));
		for( var i=0; i<paths_arr.length; ++i ) {
			var path = paths_arr[i];
			$allTargets.each( function() {
				var $trgCandidate = $(this);
				if( $trgCandidate.data('path')===path ) {
					fn($trgCandidate);
				}
			} );
		}
	}

	function markDescendants( parentId, depth ) {
		var $descendants = $('#dprint .tcell-csp.style-topo-dep.csppc-'+parentId);
		if( $descendants.length===0 ) return;
		var alpha_deps    = clip( 0.25 + 0.75*( depth===0 ? 1 : 1.0/Math.min(5,depth) ), 0.2, 1 );
		$descendants
			.addClass('tcell-descendant')
			.css({
				background:'rgba(0,136,0,'+alpha_deps+')',
			})
			.each( function(i,v) {
				applyStylesOnTarget($(this),depth);
			});
	}

	function applyStylesOnDependentTarget( $dependentTrg, depth ) {
		if( $dependentTrg.length===0 ) return;
		var cspc = $dependentTrg.data('cspc');
		var path = $dependentTrg.data('path');
		selectedPaths.push(path);
		var alpha_self = clip( 0.25 + 0.75*( depth===0 ? 1 : 1.0/Math.min(5,-depth) ), 0.2, 1 );

		// all instances of target element:
		$('#dprint .tcell-csp.cspc-'+cspc)
			.addClass('tcell-dependent')
			.css({
				background:'rgba(0,0,136,'+alpha_self+')',
			})
			.find('.tcell-rank').text(depth).end();

		// dependents of dependents too ??
	}


	function applyStylesOnTarget( $curTrg, depth ) {
		if( $curTrg.length===0 ) return;
		var cspc = $curTrg.data('cspc');
		// var csppc = $curTrg.data('cspc');
		var path = $curTrg.data('path');
		selectedPaths.push(path);
		var alpha_self = clip( 0.25 + 0.75*( depth===0 ? 1 : 1.0/Math.min(5,depth) ), 0.2, 1 );

		// target element:
		$curTrg
			.find('.tcell-rank')
			.text(depth);

		// other instances of target element:
		$('#dprint .tcell-csp.style-topo-path.cspc-'+cspc)
			.not($curTrg)
			.addClass('tcell-other-instances')
			.css({
				background:'rgba(136,0,0,'+alpha_self+')',
			})
			.find('.tcell-rank').text(depth).end();

		// descendants of target:
		markDescendants(cspc,depth+1);
	}

	var dep_styles_processed = [];
	function findAndMarkDependentStyleTargets( path, depth ) {
		if( depth===-1 ) dep_styles_processed = [];

		var i, dep_path;
		var filtered_sp_arr = [];

		var dependent_style_paths_arr = get_styles_dependent_on(path);
		for( i=0; i<dependent_style_paths_arr.length; ++i ) {
			dep_path = dependent_style_paths_arr[i];
			if( arr_inArray(dep_path,dep_styles_processed)===-1 ) {
				filtered_sp_arr.push(dep_path);
				dep_styles_processed.push(dep_path);
			}
		}
		if( filtered_sp_arr.length===0 ) return;

		withEachStyleTargetByPath(filtered_sp_arr,function( $dependentTrg ) {
			applyStylesOnDependentTarget( $dependentTrg, depth );
		});

		for( i=0; i<filtered_sp_arr.length; ++i ) {
			dep_path = filtered_sp_arr[i];
			findAndMarkDependentStyleTargets(dep_path,depth-1);
		}
	}


	function showTopoView( topoViewElem, node_filter_fn, filesize_view ) {

		var ovl_opts = {
			'OverlayCssClass':'dprint-text',
			'OverlayCssWidth':'auto',
			'OffsetParent':$('#page'),
			'WrapOverlayContents':false,
			'OkButtonText':null,
			'CancelButtonText':null,
			OnShow: function( ovl ) {
				ovl.attr('tabindex',0);
				ovl.focus();
			},
		};

		mjWidgetOverlayEditor.open(
			topoViewElem,
			null,
			function setup_cb( elem, val, ovl ) {

				ovl.css({
					zIndex:$('#dprint').css('zIndex')+1,
					top:'5px',
					left:'5px',
					overflow:'auto',
					background:'rgba(2,26,51,1)',
				});

				$('<div class="dprint-block-head"><span class="trow" style="margin:6px 4px 4px 6px"><span class="tcell">'+'Stylesheet Dependencies View'+'</span></span></div>')
					.appendTo(ovl);

				ovl.show();

				var data = {
					nodes: new vis.DataSet(),
					edges: new vis.DataSet(),
				};

				var i, d, entry, l=mj.debug.styles_involved.length;

				var max_node_level = 0;
				for( i=0; i<l; ++i ) {
					entry = mj.debug.styles_involved[i];
					if( entry.level && entry.level > max_node_level ) max_node_level = entry.level;
				}

				for( i=0; i<l; ++i ) {
					entry = mj.debug.styles_involved[i];

					if( node_filter_fn && !node_filter_fn(entry.path) ) continue;

					var node_color = '#cccccc';
					var html_label = colorized_skin_path_html(entry.path);
					var p = html_label.indexOf('color:');
					if( p!=-1 ) node_color = html_label.substr(p+6,7);

					var node_label = entry.path;
					node_label += '\n' + MDLocale.fmt_filesize(entry.size,true);
					node_label += '\n' + MDLocale.fmt_duration_fancy(entry.dmtime,true,3);

					var is_css =  entry.path.endsWith('.css');

					var border_color = tinycolor(node_color).desaturate(33).darken(44).toHex8String();
					var entry_group = is_css ? 'css' : 'less';

					if( is_css ) {
						node_color = tinycolor(node_color).brighten(22).toHex8String();
						border_color = tinycolor(border_color).brighten(22).toHex8String();
					}

					var dn = {
						id: entry.path,
						label: node_label,
						borderWidth: 2,
						color: {
							background: node_color,
						},
						value: entry.size,
						group: entry_group,
						level: entry.sent ? max_node_level : entry.level,
					};
					if( !filesize_view ) {
						dn.shape = is_css ? 'ellipse' : 'box';
						dn.color.border = border_color;
						if( entry.sent ) {
							dn.color.background = '#FFFFFF';
							dn.shape = 'ellipse';
							dn.font = { bold:true, color:'#000000' };
						}
					}
					data.nodes.add([dn]);
				}

				for( i=0; i<l; ++i ) {
					entry = mj.debug.styles_involved[i];
					if( entry.deps ) {
						var to = entry.path;
						var to_is_css = to.endsWith('.css');
						for( d=0; d<entry.deps.length; ++d ) {
							var from = entry.deps[d];
							var from_is_css = from.endsWith('.css');
							var dashes = !from_is_css && to_is_css;
							var en = {
								from: from,
								to: to,
								dashes: dashes,
							};
							en.label = !from_is_css && to_is_css
								? 'less2css'
								: ( from_is_css && to_is_css
									? 'css2css'
									: '@import'
								);
							data.edges.add([en]);
						}
					}
				}

				var options = {
					autoResize: true,
					height: '100%',
					width: '100%',
					locale: 'en',
					layout: {
						hierarchical: {
							enabled: true,
							sortMethod: 'hubsize',
							parentCentralization: true,
							blockShifting: true,
							edgeMinimization: true,
							direction: 'UD',
							nodeSpacing: 400,
							levelSeparation: 250,
							treeSpacing: 385,
						},
						randomSeed: 142,
					},
					edges: {
						smooth: true,
						arrows: {
							to: true,
						},
						font: {
							size: 16,
						},
						selfReferenceSize: 30,
						color: {
							inherit: 'both',
						},
					},
					nodes: {
						shape: 'box',
						color: {
							border: '#cccccc',
							hover: {
								background: '#FFFFFF',
								border: '#000000',
							},
						},
						margin: 10,
						font: {
							size: 16,
							color: '#333333',
						},
						shadow: true,
					},
					interaction: {
						hover: true,
						hoverConnectedEdges: true,
						dragNodes: true,
						selectConnectedEdges: true,
					},
					physics: {
						enabled: false,
						stabilization: true,
					},
				};

				options.edges.smooth = {
					type: 'discrete',
					forceDirection: 'none',
					"roundness": 0.25,
				};
				options.physics = {
					enabled: true,
					stabilization: true,
					solver: 'hierarchicalRepulsion',
					minVelocity: 0.34,
					timestep: 0.23,
					hierarchicalRepulsion: {
						centralGravity: 4.15,
						springLength: 10,
						springConstant: 0.24,
						nodeDistance: 480,
						damping: 0.125,
					},
				};

				if( filesize_view ) {
					options.nodes.shape = 'dot';
					options.nodes.scaling = {
						customScalingFunction: function( min, max, total, value ) {
							return value/total;
						},
						min:20,
						max:300,
					};
					options.nodes.font.color = '#ffffff';
				}

				var network = new vis.Network(ovl[0],data,options);
				network.on('doubleClick', function( params ) {
					if( params.nodes && params.nodes[0] ) {
						var style_path = params.nodes[0];
						if( style_path.startsWith('public/') ) style_path = style_path.substr(7);
						var url = style_path;
						window.open(url,'_blank');
					}
				});
				network.on('stabilizationIterationsDone', function() {
					network.setOptions( { physics:false } );
				});

			},
			null,
			null,
			null,
			ovl_opts
		);

	}

	function loadAndShowTopoView( topoViewElem, node_filter_fn, filesize_view ) {
		if( vis ) {
			showTopoView( topoViewElem, node_filter_fn, filesize_view );
		} else {
			import('../entry/vis-network.js')
				.then( (module) => {
					vis = module;
					showTopoView( topoViewElem, node_filter_fn, filesize_view );
				} )
				.catch( (error) => {
					console.error(error);
				} );
		}
	}


	function focusTarget( $curTrg, x ) {
		$('#dprint .tcell-csp')
			.css({background:''})
			.removeClass('tcell-selected tcell-descendant tcell-dependent tcell-other-instances')
			.find('.tcell-rank').empty();

		$('#dprint').find('.tcell-topo-link,.tcell-dependent-link,.tcell-file-link').remove();

		selectedPaths = [];

		$curTrg.addClass('tcell-selected');
		applyStylesOnTarget( $curTrg, 0 );

		var topoViewElem = $('<span class="tcell-topo-link link">[graph]</span>').insertAfter($curTrg);
		topoViewElem.on( 'click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			loadAndShowTopoView( topoViewElem, function( path ) {
				if( arr_inArray(path,selectedPaths)==-1 ) return false;
				return true;
			});
		} );

		var path = $curTrg.data('path');
		var dependentViewElem = $('<span class="tcell-dependent-link link">[add dependent]</span>').insertAfter($curTrg);
		dependentViewElem.on( 'click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			findAndMarkDependentStyleTargets(path,-1);
		} );


		var href = path.startsWith('public/') ? path.substr(7) : path;
		$('<a class="tcell-file-link link" target="_blank">[file]</a>')
			.attr('href',href)
			.insertAfter($curTrg);

	}


	var lastClickTarget = null;
	$('#dprint').on( 'click focusin', '.tcell-csp', function( e ) {
		var $curEvtTarget = $(e.currentTarget);
		e.preventDefault();
		e.stopPropagation();
		if( e.type==='click' ) {
			if( e.currentTarget===lastClickTarget ) {
				var topoViewLink = $curEvtTarget.find('.tcell-topo-link');
				if( topoViewLink.length ) topoViewLink.trigger('click');
				lastClickTarget = null;
			} else {
				focusTarget( $curEvtTarget );
				lastClickTarget = e.currentTarget;
				$(lastClickTarget).focus();
			}
		} else if( e.type==='focusin' ) {
			focusTarget( $curEvtTarget );
		}
	} );


	function setup_additional_style_debug_utils() {
		$('<div class="dprint-button">Style Filesize Comparison</div>')
			.appendTo('#dprint-toolbar')
			.on( 'click', function() {
				loadAndShowTopoView( $(this), function( path ) {
					return true;
				}, true );
			});

		$('<div class="dprint-button">Whole Style Dependency Graph..</div>')
			.appendTo('#dprint-toolbar')
			.on( 'click', function() {
				loadAndShowTopoView( $(this), function( path ) {
					return true;
				});
			});
	}

	const epsilon = 2;
	const ops = {
		lt:  function( a, b ) {
			return a+epsilon < b;
		},
		lte: function( a, b ) {
			return a+epsilon <= b;
		},
		gt:  function( a, b ) {
			return a > b+epsilon;
		},
		gte: function( a, b ) {
			return a >= b+epsilon;
		},
		eq:  function( a, b ) {
			return Math.abs(a-b) < epsilon;
		},
	};

	MVPageDebug.setKeydownHandler( function(e) {
		if( e.ctrlKey || e.metaKey ) return true; // ignore

		var all_nodes = $('#dprint .tcell-csp');
		if( all_nodes.length===0 ) return true;

		var focused_node = all_nodes.first();
		if( elementHasClassName(document.activeElement,'tcell-csp') ) {
			focused_node = $(document.activeElement);
		}
		var focused_idx = focused_node.length ? all_nodes.index(focused_node[0]) : 0;
		var nodes_count = all_nodes.length;

		var fno = focused_node.position();
		var xno;
		switch( e.which ) {
		case 37: 	// LEFT
			if( focused_idx>0 ) {
				for( --focused_idx; focused_idx>=0; --focused_idx ) {
					xno = (all_nodes.eq(focused_idx)).position();
					if( ops.lte(xno.top,fno.top) ) {
						if( ops.eq(xno.left,fno.left) ) break;
					} else {
						if( ops.lt(xno.left,fno.left) ) break;
					}
				}
			}
			break;
		case 39: 	// RIGHT
			if( focused_idx<nodes_count-1 ) {
				for( ++focused_idx; focused_idx<nodes_count; ++focused_idx ) {
					xno = (all_nodes.eq(focused_idx)).position();
					if( ops.gte(xno.top,fno.top) ) {
						if( ops.eq(xno.left,fno.left) ) break;
					} else {
						if( ops.gt(xno.left,fno.left) ) break;
					}
				}
			}
			break;
		case 38:	// UP
			if( focused_idx>0 ) {
				for( --focused_idx; focused_idx>0; --focused_idx ) {
					xno = (all_nodes.eq(focused_idx)).position();
					if( ops.lt(xno.top,fno.top) && ops.eq(xno.left,fno.left) ) break;
				}
			}
			break;
		case 40: 	// DOWN
			if( focused_idx<nodes_count-1 ) {
				for( ++focused_idx; focused_idx<nodes_count; ++focused_idx ) {
					xno = (all_nodes.eq(focused_idx)).position();
					if( ops.gt(xno.top,fno.top) && ops.eq(xno.left,fno.left) ) break;
				}
			}
			break;
		default:
			// ignore other key presses
			return false;
		}
		focused_node = all_nodes.eq(focused_idx);
		if( focused_node.length ) focused_node.focus();

		e.preventDefault();
		e.stopPropagation();
		return false;
	} );





	function update_web_ui_debugging_modes_view() {
		$('#web-ui-debugging-overlay .web-ui-debugging-mode').each( function() {
			const mode_div = $(this);

			const modeData = mode_div.data('web-ui-debugging-mode-data');
			const isEnabled = $.cookie(modeData.cn) == modeData.cv;

			mode_div.toggleClass('enabled',isEnabled);
			mode_div.find('>span.state').toggleClass('fa-check-circle-o',isEnabled).toggleClass('fa-circle-o',!isEnabled);
		} );
	}

	function apply_web_ui_debugging_modes( all_modes, enable_modes ) {
		for( const [modeName,modeData] of Object.entries(all_modes) ) {
			const enable = enable_modes.indexOf(modeName) >= 0;
			const dbgCookieOpts = {
				...mj.cookieopts,
				path: modeData.p,
			};
			if( enable ) $.cookie(modeData.cn,modeData.cv,dbgCookieOpts);
			else $.cookie(modeData.cn,null,{...dbgCookieOpts,expires:0});
		}
	}

	function parse_web_ui_debugging_modes() {
		let all_modes = {};
		let enable_modes = [];
		$('#web-ui-debugging-overlay .web-ui-debugging-mode').each( function() {
			const mode_div = $(this);
			var modeName = mode_div.data('web-ui-debugging-mode');
			var modeData = mode_div.data('web-ui-debugging-mode-data');
			all_modes[modeName] = modeData;
			if( mode_div.is('.enabled') ) {
				enable_modes.push(modeName);
			}
		} );
		return [all_modes,enable_modes];
	}

	$('#web-ui-debugging-overlay .web-ui-debugging-mode').click( function() {
		const mode_div = $(this);
		const newState = !mode_div.hasClass('enabled');

		if( newState ) {
			// toggle off all other modes
			const other_mode_divs = mode_div.siblings('.web-ui-debugging-mode');
			other_mode_divs.removeClass('enabled');
			other_mode_divs.find('>span.state').removeClass('fa-check-circle-o').addClass('fa-circle-o');
		}

		// toggle
		mode_div.toggleClass('enabled',newState);
		mode_div.find('>span.state').toggleClass('fa-check-circle-o',newState).toggleClass('fa-circle-o',!newState);

		const [all_modes,enable_modes] = parse_web_ui_debugging_modes();
		apply_web_ui_debugging_modes(all_modes,enable_modes);
		requestAnimationFrame( function() {
			update_web_ui_debugging_modes_view();
		} );
	} );


	update_web_ui_debugging_modes_view();
}

